import { render, staticRenderFns } from "./pointsRulesEdit.vue?vue&type=template&id=d541b78e&scoped=true"
import script from "./pointsRulesEdit.vue?vue&type=script&lang=js"
export * from "./pointsRulesEdit.vue?vue&type=script&lang=js"
import style0 from "./pointsRulesEdit.vue?vue&type=style&index=0&id=d541b78e&prod&lang=less&scoped=true"
import style1 from "./pointsRulesEdit.vue?vue&type=style&index=1&id=d541b78e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d541b78e",
  null
  
)

export default component.exports